import React from 'react'
import ODALogoIcon from '../../assets/logo_petal.svg'
import ODALogo from'../../assets/logos/oda_logo.svg'
import HomeHeroBanner from '../../assets/heroBanner.svg'
import OurVoicesHeroBanner from '../../assets/ourvoices-hero-image.svg'
import ImageCollab2 from '../../assets/PochaCrew.jpg'
import tarjetaVerde1 from '../../assets/Tarjeta-Verde_know-your-rights-in-mexico.jpg'
import tarjetaVerdeEsp from '../../assets/Tarjeta-Verde_conoce-tus-derechos-en-mexico.jpg'
import TarjetVerdeTalk from '../../assets/tarjeta-verde-talk.png'
import Image from '../../assets/acompana.svg'

// social
import { AiFillInstagram } from "react-icons/ai";
import { AiOutlineFacebook } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FiArrowUpRight } from "react-icons/fi";
import { AiFillHeart } from "react-icons/ai";

import './index.css'

function Home() {
    return (<>
        <div className="Home">
            <section className="hero-section">
                <img className="main_first_picture" src={HomeHeroBanner} alt="otros dreams en accion pocha house" />
                <div>
                    <p>ODA’s llamita es que nuestra community aquí y allá sepa que no son les únicos.</p>
                    <p><b><i>Que sepan que no están soles!</i></b></p>
                </div>
            </section>
            <section className='content'>
                <div className='about-wrapper'>
                <div className="box-wrapper flex-end">
                    <img className="hero-icon small" src={ODALogoIcon} alt="otros dreams en accion pocha house" />
                    <p className="home-text-description-large"><b>Otros Dreams en Acción (ODA)</b> is an organization led by returned and deported migrants that seeks alliances with other social sectors to overcome challenges and transform policies affecting return migration and deportation in Mexico from a human rights perspective.</p>
                    <span className='flex'>
                        <a
                            href='https://drive.google.com/file/d/1GMFg6JfCwhYWTPvL7coqtzeqKLo-U08o/view?usp=sharing'
                            className="home-text-description"
                        >Anual Report 2024</a>
                        <a
                            href='https://drive.google.com/file/d/14dVR4Cu1pG83oqZNAV4duwNkznMs4IUK/view?usp=sharing'
                            className="home-text-description"
                        >Reporte Anual 2024</a>
                    </span>
                </div>
                <div className="box-wrapper contact-box">
                    <p className="home-text-description">Need accompaniment, send us a WhatsApp message at +52 55 6875 1027 or at +52 55 1495 5620
                        if not email us at <br/>retornodigno@<wbr/>odamexico.org!
                    </p>
                    <img src={Image} className='small-image-cover' alt='Freedom of Information Act (FOIA) for deportee and returnee'/>
                </div>
                </div>
            </section>
            {/* <section className='content'>
                <div className=''>
                    <img className="main_first_picture" src={OurVoicesHeroBanner} alt="otros dreams en accion pocha house" />
                    <div className='flex'>
                        <h3>Join the lucha Aqui y Alla!</h3>
                        <div>Donate</div>
                    </div>
                </div> */}
{/* 
                <div className="box-wrapper table-wrapper">
                    <div className="table-title">
                        <h2 className="home-table-title">Some of our Projects</h2>
                        <AiFillHeart color='#ffbfbf' size={28} title='close navigation menu'/>
                    </div>
                    <img className="table-image" src={ImageCollab2} alt=""/>
                    <a href="http://lxsotrxsdreamers.odamexico.org/" className="table-item">
                        Lxs Otros Dreamers Book
                    </a>
                    <a href="https://www.odamexico.org/tarjeta-verde" className="table-item">
                        Tarjeta Verde: Know Your Rights in Mexico
                    </a>
                    <a href="http://floreceraquiyalla.mx/" className="table-item">
                        Florecer Aqui y Alla
                    </a>
                    <a href="https://www.visajustice.org/" className="table-item">
                        Visa Justice Program
                    </a>

                    <a href="https://linktr.ee/PochaHouse?utm_source=linktree_profile_share&ltsid=150c38b8-2eb6-4ab1-86be-5c5f29202f5d" className="table-item">
                        LinkTree
                    </a>
                </div>

            </section> */}

            <section className='content'>
                <div className='box-wrapper flex-end'>
                    <h3 className='promo-header-tiny'>Campaign Tarjeta Verde: Know your rights in Mexico for Returnees and Deportees</h3>
                    <div className='flex'>
                        <img
                            src={tarjetaVerde1}
                            loading="lazy"
                            alt="Otros Dreams en Acción (ODA) Campaign Tarjeta Verde: Know your rights in Mexico"
                            className="home-anouncement-image"
                        />
                        <p className="home-text-description-large">
                            In collaboration with Comunidad en Retorno, Otros Dreams en Acción, and the Coalición de Migrantes Mexicanos, through the example of the <a href="https://www.ilrc.org/red-cards-tarjetas-rojas" className="red-card-home-banner-link">
                                Red Card created by Immigrant Legal Resource Center (ILRC)
                            </a> we have been designing tools for deportees and returnees to “Know Your Rights in Mexico”.
                        </p>
                        <img
                            src={tarjetaVerdeEsp}
                            loading="lazy"
                            alt="Otros Dreams en Acción (ODA) Campaña Tarjeta Verde: Conoce tus derechos en México para deportados y retornados"
                            className="home-anouncement-image"
                        />

                    </div>
                </div>
            </section>
            <section className="footer-wrapper">
                    <div className='footer-item-wrapper'>
                        <div>
                        <p className="footer-title">Contact us:</p>
                        <div className="footer-text-wrapper">
                            <AiOutlineWhatsApp size={48} color='#fff' style={{margin: 'auto 12px auto 0'}} />
                            <span className="footer-text-small">
                                <a className="contactItem" aria-label="Chat on WhatsApp" href="https://wa.me/525568751027" target="_blank" rel="noreferrer">
                                +52 55 6875 1027</a>
                            </span>
                        </div>
                        <div className="footer-text-wrapper">
                            <AiOutlineMail size={48} color='#fff' style={{margin: 'auto 12px auto 0'}} />
                            <p className="footer-text-small contactItem">info@odamexico.org</p>
                        </div>
                    </div>
                    <div>
                        <p className='footer-title'>Follow us:</p>
                        <div className="footer-text-wrapper">
                            <a className="contactItem" aria-label="Visit ODA's Instagram" href="https://www.instagram.com/otros_dreams_en_accion/" target="_blank" rel="noreferrer">
                                <AiFillInstagram size={48} color='#fff' style={{margin: '0 12px'}}/>
                            </a>
                            <a className="contactItem" aria-label="ODA Facebook" href="https://www.facebook.com/OtrosDreams" target="_blank" rel="noreferrer">
                                <AiOutlineFacebook size={48} color='#fff' style={{margin: 'auto 12px'}} />
                            </a>
                            <a className="contactItem" aria-label="ODA Youtube" href="https://www.youtube.com/@odaotrosdreamsenaccion6686" target="_blank" rel="noreferrer">
                                <AiFillYoutube size={48} color='#fff' style={{margin: 'auto 12px'}} />
                            </a>

                        </div>
                    </div>
                    <a
                        className='fotter-donation-btn'
                        href='https://donate.odamexico.org/en'
                        rel="noreferrer"
                        target='_blank'
                    >Donate!</a>
    
                    </div>
            </section>
            {/* <div className="parent">
                <div className="div1 box-wrapper flex-end">
                    <p className="home-text">ODA’s llamita es que nuestra community aquí y allá sepa que no son les únicos.</p>
                    <p className="home-text"><b><i>Que sepan que no están soles!</i></b></p>
                </div>
                <div className='div3'>
                    <img className="main_first_picture" src={OurVoicesHeroBanner} alt="otros dreams en accion pocha house" />
                </div>

                <div className="div2 box-wrapper flex-end">
                    <img className="hero-icon small" src={ODALogoIcon} alt="otros dreams en accion pocha house" />
                    <p className="home-text-description"><b>Otros Dreams en Acción (ODA)</b> is an organization led by returned and deported migrants that seeks alliances with other social sectors to overcome challenges and transform policies affecting return migration and deportation in Mexico from a human rights perspective.</p>
                </div>
                <div className="div5 box-wrapper">
                    <div className="table-title">
                        <h2 className="home-table-title">Some of our Projects</h2>
                        <AiFillHeart color='#ffbfbf' size={28} title='close navigation menu'/>
                    </div>
                    <img className="table-image" src={ImageCollab2} alt=""/>
                    <a href="http://lxsotrxsdreamers.odamexico.org/" className="table-item">
                        Lxs Otros Dreamers Book
                    </a>
                    <a href="https://www.odamexico.org/tarjeta-verde" className="table-item">
                        Tarjeta Verde: Know Your Rights in Mexico
                    </a>
                    <a href="http://floreceraquiyalla.mx/" className="table-item">
                        Florecer Aqui y Alla
                    </a>
                    <a href="https://www.visajustice.org/" className="table-item">
                        Visa Justice Program
                    </a>

                    <a href="https://linktr.ee/PochaHouse?utm_source=linktree_profile_share&ltsid=150c38b8-2eb6-4ab1-86be-5c5f29202f5d" className="table-item">
                        LinkTree
                    </a>

                </div>
                <div className="div4 box-wrapper">
                    <p className="home-text-description">Need accompaniment, send us a WhatsApp message at +52 55 6875 1027 or at +52 55 1495 5620
                        if not email us at <br/>retornodigno@<wbr/>odamexico.org!
                    </p>
                    <img src={Image} alt='Freedom of Information Act (FOIA) for deportee and returnee'/>
                </div>


                <div className="div6 box-wrapper secondary-light">
                    <a href="https://www.instagram.com/p/DOPTJlxDyWo/?img_index=1" className="">
                    <img className="event-image" src={TarjetVerdeTalk} alt="otros dreams en accion pocha house" />
                    </a>
                    <p className="home-text-description-small greyDark-text">Te invitamos a nuestro <b>Primer Mega Pocha Q&A</b>. We’re going to talk bout’ identity documents, educación, ahorro, propiedades y derecho a la salud; when you’re facing or thinking bout’ a process of return or deportation to México.
                        It will be our first Q&A interpretado en Tzotzil e Inglés.<br/>
                        <br/>
                        ✍️Please register in this link <b><a href="https://form.jotform.com/252458301070852">form.jotform.com/252458301070852</a></b>
                    </p>
                </div>


                <div className='div9 box-wrapper primary-50'>
                    <h3 className='promo-header-tiny'>Campaign Tarjeta Verde: Know your rights in Mexico for Returnees and Deportees</h3>
                    <div className='home-anouncement-text-wrapper'>
                        <img
                            src={tarjetaVerde1}
                            loading="lazy"
                            alt="Otros Dreams en Acción (ODA) Campaign Tarjeta Verde: Know your rights in Mexico"
                            className="home-anouncement-image"
                        />
                        <p className="home-text-description-large">
                            In collaboration with Comunidad en Retorno, Otros Dreams en Acción, and the Coalición de Migrantes Mexicanos, through the example of the <a href="https://www.ilrc.org/red-cards-tarjetas-rojas" className="red-card-home-banner-link">
                                Red Card created by Immigrant Legal Resource Center (ILRC)
                            </a> we have been designing tools for deportees and returnees to “Know Your Rights in Mexico”.
                        </p>
                    </div>
                    <div className="home-anouncement-text-wrapper">
                        <div className='home-text-description'>
                            <p className="home-text-description mg-left42">
                                In the face of the rising cruelty & persecution: <i>
                                    We respond in community to accompany those who may find themselves in Mexico, like we once did.
                                </i>
                            </p>
                            <a href='https://www.odamexico.org/tarjeta-verde' className='link-card'>
                            Learn more
                            <FiArrowUpRight size={32} color='#4f4f4f'/>
                            </a>
                        </div>
                        <img
                            src={tarjetaVerdeEsp}
                            loading="lazy"
                            alt="Otros Dreams en Acción (ODA) Campaña Tarjeta Verde: Conoce tus derechos en México para deportados y retornados"
                            className="home-anouncement-image"
                        />
                    </div>
                </div>
            </div>
            <div className="footer-wrapper">
                <div className='footer-item-wrapper'>
                    <div>
                    <p className="footer-title">Contact us:</p>
                    <div className="footer-text-wrapper">
                        <AiOutlineWhatsApp size={48} color='#286380' style={{margin: 'auto 12px auto 0'}} />
                        <span className="footer-text-small">
                            <a className="contactItem" aria-label="Chat on WhatsApp" href="https://wa.me/525568751027" target="_blank" rel="noreferrer">
                            +52 55 6875 1027</a>
                        </span>
                    </div>
                    <div className="footer-text-wrapper">
                        <AiOutlineMail size={48} color='#286380' style={{margin: 'auto 12px auto 0'}} />
                        <p className="footer-text-small contactItem">info@odamexico.org</p>
                    </div>
                </div>
                <div>
                    <p className='footer-title'>Follow us:</p>
                    <div className="footer-text-wrapper">
                        <a className="contactItem" aria-label="Visit ODA's Instagram" href="https://www.instagram.com/otros_dreams_en_accion/" target="_blank" rel="noreferrer">
                            <AiFillInstagram size={48} color='#286380' style={{margin: '0 12px'}}/>
                        </a>
                        <a className="contactItem" aria-label="ODA Facebook" href="https://www.facebook.com/OtrosDreams" target="_blank" rel="noreferrer">
                            <AiOutlineFacebook size={48} color='#286380' style={{margin: 'auto 12px'}} />
                        </a>
                        <a className="contactItem" aria-label="ODA Youtube" href="https://www.youtube.com/@odaotrosdreamsenaccion6686" target="_blank" rel="noreferrer">
                            <AiFillYoutube size={48} color='#286380' style={{margin: 'auto 12px'}} />
                        </a>

                    </div>
                </div>
                <a
                    className='fotter-donation-btn'
                    href='https://www.paypal.com/donate/?hosted_button_id=GSVZ4R47THR82'
                    rel="noreferrer"
                    target='_blank'
                >Donate!</a>
 
                </div>
            </div>
        </div>
        <div className="footer mg-top48">
            <img className="image" src={ODALogo} alt="Otros Dreams en Acción logo" height="95" /> */}
        </div>
    </>);
}

export default Home;
